import React, { useState } from 'react';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { localize } from '@saviynt/common';
import {
  Box,
  ToggleButton,
  ToggleButtonGroup,
  Typography,
} from '@saviynt/design-system';

import { getMessageKey } from '../../../utils/utils';
import { LinearProgressBar } from '../../Common';

import { DONE, TOTAL } from './constants';
import { ViewByDecision } from './Decision';
import { ViewByType } from './Type';
import { calculatePercentage, getPercentage } from './utils';

import './PopoverContent.css';

function PopoverContent() {
  const [selection, setSelection] = useState(1);

  const {
    progressBreakdowndetails: { byDecisionDetails },
  } = useSelector((state) => state?.certifications?.details);
  const { messages } = useSelector((state) => state?.user);

  const intl = useIntl();

  return (
    <div className='PopoverContent'>
      {byDecisionDetails?.Summary && (
        <>
          <Typography
            kind='body2-bold'
            className='PopoverContent-progressInfoTitle'>
            {messages.CERTS_EXPORT_WHAT_TO_EXPORT_ALL_ITEMS ||
              localize(
                intl,
                getMessageKey('CERTS_EXPORT_WHAT_TO_EXPORT_ALL_ITEMS')
              )}
          </Typography>
          <LinearProgressBar
            value={calculatePercentage(
              byDecisionDetails?.Summary[DONE],
              byDecisionDetails?.Summary[TOTAL]
            )}
          />
          <div className='PopoverContent-progressBreakdown'>
            <Typography
              kind='body3'
              className='PopoverContent-progressBreakdownCount'>
              {`${byDecisionDetails?.Summary[DONE]} ${
                messages.CERTS_OF_LABEL ||
                localize(intl, getMessageKey('CERTS_OF_LABEL'))
              } ${byDecisionDetails?.Summary[TOTAL]}`}
            </Typography>
            <Typography
              kind='body3'
              className='PopoverContent-progressBreakdownPercentage'>
              {getPercentage(
                byDecisionDetails?.Summary[DONE],
                byDecisionDetails?.Summary[TOTAL]
              )}
            </Typography>
            <Typography
              kind='body3-bold'
              className='PopoverContent-progressBreakdownStatus'>
              {messages.CERTS_DONE ||
                localize(intl, getMessageKey('CERTS_DONE'))}
            </Typography>
          </div>
        </>
      )}

      <div className='PopoverContent-tabs'>
        <Box>
          <div
            role='group'
            aria-label={
              messages.CERTS_PROGRESS_BREAKDOWN_VIEW_BY ||
              localize(intl, getMessageKey('CERTS_PROGRESS_BREAKDOWN_VIEW_BY'))
            }>
            <ToggleButtonGroup
              selection={selection}
              setSelection={setSelection}>
              <ToggleButton
                label={
                  messages.CERTS_BY_DECISION ||
                  localize(intl, getMessageKey('CERTS_BY_DECISION'))
                }
              />
              <ToggleButton
                label={
                  messages.CERTS_BY_TYPE ||
                  localize(intl, getMessageKey('CERTS_BY_TYPE'))
                }
              />
            </ToggleButtonGroup>
          </div>
          {selection === 1 && <ViewByDecision />}
          {selection === 2 && <ViewByType />}
        </Box>
      </div>
    </div>
  );
}

export default PopoverContent;
